<template lang="pug">
  .container.grid-lg.py-2
    loading.v-loading(:loading='loading')
    .card
      .card-body
        form-group(:label="'doc_publicacao.descricao' | tModel" :validation='$v.current.descricao')
          input.form-input(type='text' v-model='$v.current.descricao.$model' :placeholder="'doc_publicacao.descricao' | tModel")
        .columns
          .column.col-auto
            form-group(:label="'doc_publicacao.numero' | tModel" :validation='$v.current.numero')
              int.form-input(type='text' v-model='$v.current.numero.$model' :placeholder="'doc_publicacao.numero' | tModel")
          .column.col-auto
            form-group(:label="'doc_publicacao.ano' | tModel" :validation='$v.current.ano')
              year.form-input(v-model='$v.current.ano.$model' :placeholder="'doc_publicacao.ano' | tModel")
          .column
            form-group(:label="'doc_publicacao.publicado_em' | tModel" :validation='$v.current.publicado_em')
              datepicker(v-model='$v.current.publicado_em.$model' :placeholder="'doc_publicacao.publicado_em' | tModel")
      .card-footer.text-right
        button.btn.btn-primary(:class="{'loading': loading}", @click='save', :disabled='$v.$invalid || loading')
          btn-content(name='save')
</template>

<script>
import DocPublicacao from '@/models/DocPublicacao'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      getters: ['loading'],
      actions: ['fetchCreate'],
    },
  },
  data() {
    return { current: new DocPublicacao() }
  },
  methods: {
    save() {
      this.fetchCreate(this.current.postParams)
        .then(res => {
          this.$toaster.success('Salvo com sucesso.')
          this.$router.push({ name: 'fiscalizacao.docPublicacoes' })
        })
        .catch(e => {
          this.$toaster.error(this.$parseErrors(e).join(', '))
        })
    },
  },
  validations: {
    current: DocPublicacao.validations,
  },
}
</script>
